import { PricingPlans } from 'screens/Landing/Pricing/usePricing'

export interface RadioInputProps {
  label: string
  icon: string
  name: string
  isChecked: boolean
  value: PricingPlans
  onChange: (plan: PricingPlans) => void
}

export const useRadioInput = (props: RadioInputProps) => {
  return {
    ...props,
  }
}
